<template>
    <div class="router-view">
        <header v-if="!isMobile" class="header-view">
            <div class="header flex-between" :class="[shadow ? 'header-shadow' : '']">
                <div class="flex-center">
                    <img class="logo" src="../../assets/images/logo.png" alt=""></img>
                    <p class="title">
                        <span class="text-color-black">Ví bắc nam</span>
                    </p>
                </div>
                <div class="flex-center">
                    <span class="menu" :class="[$route.path == '/' ? 'menu-selected' : '']"
                        @click="routerPush('/')">Trang chủ</span>
                    <span class="menu" :class="[$route.path == '/privacy' ? 'menu-selected' : '']"
                        @click="routerPush('/privacy')">Thỏa thuận bảo mật</span>
                    <!-- <span class="menu" :class="[$route.path == '/account' ? 'menu-selected' : '']"
                        @click="routerPush('/account')">Vấn đề về tài khoản</span>
                    <div @click="toGP" class="header-button pointer">Đăng ký ngay</div> -->
                    <div @click="toAcc" class="header-button pointer">Vấn đề về tài khoản</div>
                </div>
            </div>
        </header>
        <header v-else lass="header-view">
            <div class="m-header flex-between">
                <div class="flex-center">
                    <img class="logo" src="../../assets/images/logo.png" alt=""></img>
                    <p class="title">
                        <span class="text-color-black">Ví bắc nam</span>
                    </p>
                </div>
                <i class="el-icon-s-operation font-20" @click="drawer = true"></i>

                <!-- <div class="flex-center">
                    <span class="menu" :class="[$route.path == '/' ? 'menu-selected' : '']"
                        @click="routerPush('/')">Trang chủ</span>
                    <span class="menu" :class="[$route.path == '/privacy' ? 'menu-selected' : '']"
                        @click="routerPush('/privacy')">Thỏa thuận bảo mật</span>
                </div> -->
            </div>
        </header>

        <router-view ref="scrollContainer" :key="$route.fullPath"
            :class="[isMobile ? 'm-router-view' : 'router-view']" />
        <footer v-if="!isMobile" class="footer">
            <div class="flex-center">
                <img class="logo-footer" src="../../assets/images/logo.png" alt=""></img>
                <span class="font-18 weight-bold">Ví bắc nam</span>
            </div>
            <div class="footer-info">
                <div class="fi-item">
                    <p class="font-18 weight-bold">Email CSKH</p>
                    <p class="m-top text-color-gray font-16">cshelp@vibacnam.com</p>
                </div>
                <div class="fi-item">
                    <p class="font-18 weight-bold">Tên công ty</p>
                    <p class="m-top text-color-gray font-16">L4B SOFTWARE INC</p>
                </div>
                <div class="fi-item">
                    <p class="font-18 weight-bold">Địa chỉ công ty</p>
                    <p class="m-top text-color-gray font-16">5201 Great America Pkwy Ste 320 Santa Clara, CA</p>
                </div>
            </div>
        </footer>
        <footer v-else class="m-footer">
            <div class="flex-center">
                <img class="logo-footer" src="../../assets/images/logo.png" alt=""></img>
                <span class="font-14 weight-bold">Ví bắc nam</span>
            </div>
            <div class="footer-info">
                <div class="fi-item">
                    <p class="font-14 weight-bold">Email CSKH</p>
                    <p class="m-top margin-btm-middle text-color-gray font-12">cshelp@vibacnam.com</p>
                </div>
                <div class="fi-item">
                    <p class="font-14 weight-bold">Tên công ty</p>
                    <p class="m-top margin-btm-middle text-color-gray font-12">L4B SOFTWARE INC</p>
                </div>
                <div class="fi-item">
                    <p class="font-14 weight-bold">Địa chỉ công ty</p>
                    <p class="m-top margin-btm-middle text-color-gray font-12">5201 Great America Pkwy Ste 320 Santa
                        Clara, CA</p>
                </div>
            </div>
        </footer>
        <el-drawer size="60%" :visible.sync="drawer" :show-close="false" direction="rtl">
            <div class="flex-colum-start m-drawer">
                <span class="menu" :class="[$route.path == '/' ? 'menu-selected' : '']" @click="routerPush('/')">Trang
                    chủ</span>
                <span class="menu" :class="[$route.path == '/privacy' ? 'menu-selected' : '']"
                    @click="routerPush('/privacy')">Thỏa thuận bảo mật</span>
                <span @click="toAcc" class="menu">Vấn đề về tài khoản</span>
            </div>
        </el-drawer>
    </div>
</template>

<script>

export default {
    name: 'TarBars',
    components: {},
    data() {
        return {
            drawer: false,
            shadow: false
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {
        window.addEventListener('scroll', this.listenScroll, true)

        if (!this.isMobile) {
            this.getScreen(1440)
            window.onresize = () => {
                this.getScreen(1440)
            };
        } else {
            this.getScreen(375)
            window.onresize = () => {
                this.getScreen(375)
            };
        }
    },
    methods: {
        listenScroll(e) {
            let scrollTop = document.documentElement.scrollTop;
            if (scrollTop > 50) {
                this.shadow = true
            } else {
                this.shadow = false
            }
        },
        toGP() {
            // window.open("https://play.google.com/store/apps/details?id=com.vn.vayuytin");
        },

        toAcc() {
            window.open("https://acct.vibacnam.com/");
        },
        routerPush(val) {
            this.$router.push(val);
            this.drawer = false;
        },

        getScreen(val) {
            let u = navigator.userAgent;
            let zoom = 0;
            zoom = window.innerWidth / val;
            document.getElementsByTagName('body')[0].style.zoom = zoom;
        },
    }
}
</script>
<style lang="scss" scoped>
.router-view {
    width: 100%;

    .header-shadow {
        box-shadow: 0px 20px 16px 0px rgba(173, 173, 173, 0.3);
    }

    .header {
        width: 100%;
        padding: 22px 100px;
        background-color: #ffffff;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;
        color: #160F2D;

        .logo {
            width: 40px;
            height: 40px;
            margin-right: 10px;
        }

        .title {
            font-size: 18px;
            font-weight: 800;
        }

        .menu {
            display: inline-block;
            font-size: 16px;
            padding: 0 28px;
            cursor: pointer;
            width: 240px;
            text-align: right;
        }

        .menu::before {
            content: '';
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #ffffff;
            margin-right: 4px;
            margin-bottom: 1px;
        }

        .menu-selected {
            color: #FF4C3F;
            font-weight: bold;
            width: 240px;
            text-align: right;
        }

        .menu-selected::before {
            content: '';
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #FF4C3F;
            margin-right: 4px;
            margin-bottom: 1px;
        }

        .header-button {
            font-size: 14px;
            background: linear-gradient(259deg, #FFC56F 11%, #FF3B3B 93%);
            border-radius: 6px;
            padding: 8px 12px;
            color: #ffffff;
            margin-left: 60px;
        }
    }

    .m-header {
        width: 100%;
        padding: 16px 12px;
        background-color: #ffffff;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;
        color: #160F2D;

        .logo {
            width: 20px;
            height: 20px;
            margin-right: 10px;
        }

        .title {
            font-size: 14px;
            font-weight: 800;
        }

    }

    .body-view {
        background-color: #FAFAFC;
        width: 100%;
        padding-top: 80px;
    }

    .m-router-view {
        background-color: #FAFAFC;
        width: 100%;
        padding-top: 54px;
    }

    .footer {
        background-color: #160F2D;
        padding: 80px 100px 110px 100px;
        color: #ffffff;

        .logo-footer {
            width: 40px;
            height: 40px;
            margin-right: 10px;
        }

        .footer-info {
            margin-top: 40px;
            padding-top: 40px;
            border-top: 1px solid #909098;
            display: flex;
        }

        .fi-item {
            margin-right: 100px;
        }
    }

    .m-footer {
        background-color: #160F2D;
        padding: 20px;
        color: #ffffff;

        .logo-footer {
            width: 20px;
            height: 20px;
            margin-right: 10px;
        }

        .footer-info {
            margin-top: 20px;
            padding-top: 20px;
            border-top: 1px solid #909098;
        }
    }
}

.m-drawer {
    padding: 0 20px;

    .menu {
        display: inline-block;
        font-size: 16px;
        padding: 0 12px;
        cursor: pointer;
        padding: 10px 0;
    }

    .menu::before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #ffffff;
        margin-right: 4px;
        margin-bottom: 2px;
    }

    .menu-selected {
        color: #FF4C3F;
        font-weight: bold;
    }

    .menu-selected::before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #FF4C3F;
        margin-right: 4px;
        margin-bottom: 2px;
    }

    .header-button {
        display: inline;
        font-size: 12px;
        background: linear-gradient(259deg, #FFC56F 11%, #FF3B3B 93%);
        border-radius: 6px;
        padding: 8px 12px;
        color: #ffffff;
        margin-top: 60px;
    }
}

/deep/ .el-drawer__header {
    padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue